// Thoughts Art Details
import React from 'react';
import { useParams } from 'react-router-dom';
import { loadThoughtsMetadata } from '../components/unspokenThoughts/LoadMetadata';
import LayOut from '../components/common/Layout';
import SubHeading from '../components/common/SubHeading';
import NotFound from './NotFound';

const ThoughtDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const artPieces = loadThoughtsMetadata();
  const artPiece = artPieces.find((art) => art.id === id);

  if (!artPiece) {
    return <NotFound />;
  }

  const Component = React.lazy(() =>
    import(`../components/unspokenThoughts/${id}/${id}`).catch(() => {
      return (
        <LayOut>
          <SubHeading text="Not Found. Try Again!" customStyle="py-20" />
        </LayOut>
      );
    })
  );

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <LayOut>
        <div className="">
          <Component />
        </div>
      </LayOut>
    </React.Suspense>
  );
};

export default ThoughtDetails;
